module.exports = __webpack_public_path__ + "static/media/Btn.6f56a73b.png";